import _ from 'lodash';
import { useCustomNavigate, useServices } from '@app/hooks';
import { IntentDetails, IntentDetailsMode } from '@app/page-components/modals';

export function CreateIntentPage() {
  const { intentService } = useServices();
  const navigate = useCustomNavigate();

  return (
    <IntentDetails
      intent={intentService.initializeIntent(false)}
      mode={IntentDetailsMode.create}
      onComplete={(intent) => {
        if (intent) {
          window.apm.addNode(intent);
          window.apm.setSerializedChanged();
          window.apm.refreshApplicationTree();
        }
        navigate('intents/management');
      }}
    />
  );
}
